<script setup>
import { onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useReadinessStore, useAppStore } from '../stores';
import MilestoneCard from '../components/MilestoneCard.vue';
import MilestoneDetails from '../components/MilestoneDetails.vue';

const readinessStore = useReadinessStore()
const appStore = useAppStore()
const route = useRoute()
const readinessAreas = ref([])
watch(route, async (to, prev) => {
    if (to.params.id) {
        await fetchGuideContent(to.params.id)
    }
})

onMounted(async () => {
    await fetchGuideContent(route.params.id)
})

const fetchGuideContent = async (guideId) => {
    if (!readinessStore.readinessGuides[guideId]) {
        await readinessStore.fetchCurrentGuide(guideId)
    }
    appStore.headerTitle = readinessStore.readinessGuides[guideId].title
    readinessAreas.value = readinessStore.currentGuideContent(guideId)
}
</script>
<template>
    <div class="mx-2">
        <div class=" py-4 md:p-8  md:px-4 mb-8" v-if="readinessAreas.length">
            <div class="flex flex-col">
                <div v-for="(readinessArea, index) in readinessAreas" :id="`toc-area-${readinessArea.id}`">
                    <MilestoneCard :milestoneId="readinessArea.id" :long-description="readinessArea.long_description"
                        :short-description="readinessArea.short_description" :title="readinessArea.title"
                        :reverse="index % 2 === 0" />
                    </div>
                    <!-- :primary-image="readinessArea.primary_image.data" :title="readinessArea.title" -->
            </div>
        </div>
        <!-- :primary-image="readinessArea.primary_image.data"  -->
        <div v-for="readinessArea in readinessAreas">
            <MilestoneDetails :milestoneId="readinessArea.id" :long-description="readinessArea.long_description"
                :short-description="readinessArea.short_description"
                :checklist-items="readinessArea.milestones"
                :title="readinessArea.title"
                :activities="readinessArea.activities" />
        </div>
    </div>
</template>